/* eslint-disable no-invalid-this */

import ApiService, { ACCOUNTS_API_CONTEXT, ACCOUNTS_API_HOST } from './ApiService';

/**
 * @override
 */
class PollsService extends ApiService {

    /**
     * constructor
     */
    constructor() {
        super({ baseURL: ACCOUNTS_API_HOST });
    }

    getPollQuestions = (sort, config) => {
        if (sort.trim() !== '') {
            return this.getList(`${ACCOUNTS_API_CONTEXT}/polls?$orderby=${sort}`, config);
        } else {
            return this.getList(`${ACCOUNTS_API_CONTEXT}/polls`, config);
        }
    };

    getPollAnswers = (sort, config) => {
        if (sort.trim() !== '') {
            return this.getList(`${ACCOUNTS_API_CONTEXT}/polls?orderby=${sort}`, config);
        } else {
            return this.getList(`${ACCOUNTS_API_CONTEXT}/polls/answers`, config);
        }
    }

    /**
     * @override
     */
    create = poll_answer => {
        return this.post(`${ACCOUNTS_API_CONTEXT}/polls/answers`, poll_answer);
    };

}

const pollsService = new PollsService();

export default pollsService;

